import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import EmployeeModal from './EmployeeModal'
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import EditEmployeeModal from './EmployeeEditModal'
import RolesTab from './RolesTab'
import ModuleAccessTab from './ModuleAccessTab'
import { canView } from "../../../utils/modulePermissions";
import { attachModuleGuard, AccessDeniedCard, AccessDeniedModal } from "../../../utils/moduleGuard";
import {
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../utils/authHelper";

// This page is the "Employee_Restrctions" module. Rows in roleModuleAccess are matched
// on module_key OR module_name, so pass both spellings.
const EMPLOYEE_RESTRICTIONS_MODULE = ["Employee_Restrctions", "staff"];
// The module has THREE rows split by sub_module_name: "employees" (this Employees tab),
// "roles" (Roles tab) and "module-access" (Module Access tab). Scope this tab to
// "employees" so the roles / module-access grants can't leak in — without it, can()
// matches all three rows and grants edit/delete if ANY row allows it.
const EMPLOYEE_RESTRICTIONS_SUB = "employees";

const EDIT_RESTRICTIONS = gql`
  mutation($params: EmployeeRestrictions) {
    updateEmployeeRestrictions(params: $params)
  }
  `

const DELETE_EMPLOYEE = gql`
  mutation(
    $employee_id: ID
    ) {
        deleteEmployee(
            employee_id: $employee_id
    )
  }
`;

const GET_EMPLOYEE_ROLES = gql`
  query($institute_id: Int) {
    getEmployeeRoles(institute_id: $institute_id) {
      id
      role_name
    }
  }
`;

// Narrow the employee list to a single role. Exported (and pure) so it can be tested
// without mounting the component, which drags in Apollo HOCs, modals and the datatable.
//
// `roleFilter` is a role id, or "" for All Roles. Matching is by employee_role_id — but
// some rows come back with only role_name populated, so we fall back to comparing the
// name. Without that fallback those employees would silently disappear the moment any
// filter was applied, which looks like data loss.
export const filterEmployeesByRole = (rows, roleFilter, roles) => {
    if (!roleFilter) return rows;

    const selected = (roles || []).find((r) => String(r.id) === String(roleFilter));
    const selectedName = selected ? String(selected.role_name || "").trim().toLowerCase() : "";

    return (rows || []).filter((row) => {
        if (row.employee_role_id != null && String(row.employee_role_id) !== "") {
            return String(row.employee_role_id) === String(roleFilter);
        }
        return String(row.role_name || "").trim().toLowerCase() === selectedName;
    });
};

// Derive the class dropdown options from the branches the user has selected.
// getBranches returns each branch with its sections, and every section carries a
// class_id; we union those class_ids across the selected branches, then keep only
// the getExamClasses whose id matches so we can show the class *name* (not the id).
// Exported + pure so it can be unit tested without mounting the Apollo-wrapped tree.
export const getClassesForBranches = (selectedBranchIds, getBranches, getExamClasses) => {
    const wanted = (selectedBranchIds || []).map((id) => String(id));
    const classIds = new Set();

    (getBranches || []).forEach((branch) => {
        if (!wanted.includes(String(branch.id))) return;
        (branch.sections || []).forEach((section) => {
            if (section.class_id != null) classIds.add(String(section.class_id));
        });
    });

    // Narrowed to the classes the logged-in user is assigned (class_ids cookie), so a
    // restricted user can never delegate a class they don't hold themselves. An empty
    // assignment leaves every class of the selected branches available.
    return filterByAuthorizedIds(getExamClasses, getAuthorizedClassIds(), "id")
        .filter((cls) => classIds.has(String(cls.id)))
        .map((cls) => ({ value: cls.id, label: cls.class }));
};

// Section options follow BOTH the selected branches and the selected classes:
// keep only sections that belong to a chosen branch AND whose class_id is one of
// the chosen classes. So the list stays empty until a branch and a class are
// picked. Dedup by section id in case one surfaces under more than one branch.
// Exported + pure so it can be unit tested without mounting the Apollo tree.
export const getSectionsForSelection = (selectedBranchIds, selectedClassIds, getBranches) => {
    const wantedBranches = (selectedBranchIds || []).map((id) => String(id));
    const wantedClasses = (selectedClassIds || []).map((id) => String(id));
    if (wantedBranches.length === 0 || wantedClasses.length === 0) return [];

    const options = [];
    const seen = new Set();
    // Narrowed to the sections the logged-in user is assigned (section_ids cookie);
    // an empty assignment leaves every section of the selection available.
    const allowedSections = getAuthorizedSectionIds();

    (getBranches || []).forEach((branch) => {
        if (!wantedBranches.includes(String(branch.id))) return;
        filterByAuthorizedIds(branch.sections, allowedSections, "id").forEach((section) => {
            if (section.id == null || seen.has(String(section.id))) return;
            if (!wantedClasses.includes(String(section.class_id))) return;
            seen.add(String(section.id));
            options.push({ value: section.id, label: section.section_name });
        });
    });

    return options;
};



class EmployeeRestrictionsSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            // Flipped to true by the guard when a role without the grant clicks an action.
            accessDeniedShow: false,
            BranchesSection: {
                Title: "Create New Employee",
                btnName: "Add Employee",
            },
            tableHeaderData: {
                Title: "Employees",
            },
            rowData: [],
            editModal: false,

            Username: "",
            loginUsername: "",
            loginUsernameError: "",
            password: "",
            email: "",
            contact_no: "",
            employeeType: 0,
            defaultvalue: 0,
            branch: "",

            roles: [],
            selectedRole: "",
            roleError: "",

            // Employees-table filter. "" = All Roles. Holds a role id (as a string,
            // since <select> values are always strings).
            roleFilter: "",


            usernameError: "",
            passwordError: "",
            emailError: "",
            contact_noError: "",
            employeeTypeError: "",
            branchError: "",
            classError: "",

            employeeTypesOptions: [],
            collegeModulesOptions: [],

            modulesValue: [],
            qbsearchModules: [],

            subjectsValue: [],
            qbsearchSubjects: [],
            subjectOptions: [],

            classesOptions: [],
            preSelectedClasses: [],
            qbsearchClasses: [],

            sectionsOptions: [],
            preSelectedSections: [],
            qbsearchSections: [],
            sectionError: "",

            branchOptions: [],
            preSelectedBranches: [],
            qbsearchBranches: [],

            selectedModulesArray: [],
            selectedModulesArrayError: "",

            dataClear: 0,

            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,

            prefilledModules: [],
            finalModulesArrayPass: [],

            preSelectedSubjects: [],
            preSelectedsubjectValues: [],

            employeeId: 0,
            profileImage: "",
            uploadingImage: false,
            selectedImageBase64: "",
            selectedImageName: "",
            selectedImageFile: null,
        }

        // Scoped to the "employees" sub-module. The action buttons stay VISIBLE for every
        // role; the guard intercepts the click and opens the Access Denied modal when the
        // role lacks is_edit / is_delete.
        this.guard = attachModuleGuard(this, EMPLOYEE_RESTRICTIONS_MODULE, EMPLOYEE_RESTRICTIONS_SUB);
    }

    articlecolumns = [
        {
            dataField: "#",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "employee_name",
            text: "Name",
            sort: true,
            formatter: (cell, row) => (
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 32, height: 32, borderRadius: "50%", overflow: "hidden", background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        {row.profile_image ? (
                            <img src={row.profile_image} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        ) : (
                            <i className="fal fa-user" style={{ color: "#7c3aed", fontSize: 13 }} />
                        )}
                    </div>
                    <span style={{ fontWeight: 600, color: "#1f2937" }}>{cell}</span>
                </div>
            )
        },
        {
            dataField: "emp_mobile",
            text: "Mobile Number",
        },
        {
            dataField: "role_name",
            text: "Role",
            formatter: (cell) => cell || "--",
        },
        {
            dataField: "branch_name",
            text: "Branch",
            formatter: (cell, row) => this.renderBranchNames(row),
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: this.actionsFunc.bind(this),
            headerAlign: "center",
            align: "center"
        }
    ];

    componentDidMount() {

        let employeetypesArray = []
        let collegeModulesArray = []
        let subjectsArray = [];
        let classesArray = [];
        let branchesArray = [];

        this.props.getBranches && this.props.getBranches.map((item) => {
            branchesArray.push({ value: item.id, label: item.branch_name })
        })

        this.props.getEmployeeTypes.map((item) => {
            const newObj = {
                value: item.id,
                label: item.employee_type
            }
            employeetypesArray.push(newObj)
        })

        this.props.getCollegeModules.map((item) => {
            const newObj = {
                value: item.id,
                label: item.module_name
            }
            collegeModulesArray.push(newObj)
        })


        // Search-filter options are narrowed to the logged-in user's own assignment
        // (subject_ids / class_ids cookies); an empty assignment leaves the full list.
        filterByAuthorizedIds(
            this.props.globals.offlineExamSubjects,
            getAuthorizedSubjectIds(),
            "id"
        ).map((item) => {
            const newObj = {
                value: item.id,
                label: item.subject
            }
            subjectsArray.push(newObj)
        })

        filterByAuthorizedIds(this.props.getExamClasses, getAuthorizedClassIds(), "id").map((item) => {
            const newObj = {
                value: item.id,
                label: item.class
            }
            classesArray.push(newObj)
        })

        this.setState({ employeeTypesOptions: employeetypesArray, collegeModulesOptions: collegeModulesArray, subjectOptions: subjectsArray, classesOptions: classesArray, branchOptions: branchesArray })

        this.getRoles();
    }

    getRoles = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_EMPLOYEE_ROLES,
                variables: { institute_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            this.setState({ roles: (result.data && result.data.getEmployeeRoles) || [] });
        } catch {
            this.setState({ roles: [] });
        }
    }

    // show class & subjects only when the chosen role is a teacher
    getSelectedRoleName = () => {
        const role = this.state.roles.find((r) => String(r.id) === String(this.state.selectedRole));
        return role ? (role.role_name || "") : "";
    }

    isTeacherRole = () => this.getSelectedRoleName().trim().toLowerCase().includes("teacher")

    performanceFunc(cell, row, rowIndex, formatExtraData) {
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.showEditModal(row)}>
                <Button variant="link" name="edit" className="text-theme">
                    <i className="far fa-edit" />
                </Button>
            </div>
        </>)
    }

    DeleteFunc(cell, row, rowIndex, formatExtraData) {

        console.log("rowrowrowrowrowrow", row)
        return (

            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.deleteEmployee(row.employeeId)}>
                <Button variant="link" name="delete" className="text-danger"><i className="far fa-trash-alt" /></Button>
            </div>
        )
    }

    // getEmployeeDetails.branch_id is a comma-separated list of branch ids, so map
    // each id to its branch_name from getBranches and show all of them. Falls back to
    // the row's own branch_name (single-branch) and finally "--" when nothing matches.
    renderBranchNames = (row) => {
        const ids = row && row.branch_id != null ? String(row.branch_id).split(",").map((s) => s.trim()).filter(Boolean) : [];
        const branches = this.props.getBranches || [];

        const names = ids
            .map((id) => {
                const match = branches.find((b) => String(b.id) === String(id));
                return match ? match.branch_name : null;
            })
            .filter(Boolean);

        if (names.length === 0) {
            return row && row.branch_name ? row.branch_name : "--";
        }

        return (
            <div style={{ fontSize: 14, color: "#374151", fontWeight: 500 }}>
                {names.join(", ")}
            </div>
        );
    }

    // Single Actions column: edit + delete side by side. Both buttons are always shown;
    // the click handlers (showEditModal / deleteEmployee) run the guard first, so a role
    // without is_edit / is_delete sees the Access Denied modal instead of the action.
    actionsFunc(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-center" style={{ gap: 4 }}>
                <span onClick={() => this.showEditModal(row)} style={{ cursor: "pointer" }}>
                    <Button variant="link" name="edit" className="text-theme"><i className="far fa-edit" /></Button>
                </span>
                <span onClick={() => this.deleteEmployee(row.employeeId)} style={{ cursor: "pointer" }}>
                    <Button variant="link" name="delete" className="text-danger"><i className="far fa-trash-alt" /></Button>
                </span>
            </div>
        )
    }

    showEditModal = (data) => {
        // is_edit gate — opens Access Denied and stops before the edit form appears.
        if (!this.guard.requireEdit()) return;
        this.setState({
            editModal: true,
            Username: data.employee_name,
            loginUsername: data.username || "",
            loginUsernameError: "",
            branch: data.branch_name,
            password: data.password,
            email: data.emp_email,
            contact_no: data.emp_mobile,
            preSelectedsubjectValues: data?.subject_ids ? data.subject_ids.split(',') : [],
            selectedRole: data.employee_role_id ? String(data.employee_role_id) : "",
            roleError: "",
            employeeId: data.employeeId,
            profileImage: data.profile_image || "",
            uploadingImage: false,
            selectedImageBase64: "",
            selectedImageName: "",
            selectedImageFile: null,
        })

        let array = [];

        // moduleAcsess is null when the employee has no saved module_access — guard it.
        const moduleAcsess = data.moduleAcsess || [];

        moduleAcsess.map((item, index) => {
            this.props.getCollegeModules.map((item2) => {
                if (item.module_name == item2.module_name) {
                    const newObj = {
                        value: item2.id,
                        label: item.module_name
                    }
                    array.push(newObj)
                }
            })
        })

        this.setState({
            prefilledModules: array
        })

        moduleAcsess.map((item) => {
            delete item.__typename
        })
        this.setState({
            finalModulesArrayPass: moduleAcsess
        })

        let onloadSubjects = data?.subject_ids?.split(",")

        console.log("onloadSubjects", onloadSubjects)

        let totalSubjects = this.props.globals.offlineExamSubjects

        let array3 = [];

        if (onloadSubjects != undefined) {
            totalSubjects.map((item) => {
                onloadSubjects.map((item2) => {
                    if (item.id == item2) {
                        const newObj = {
                            value: item.id,
                            label: item.subject
                        }
                        array3.push(newObj)
                    }
                })
            })
        }

        this.setState({
            preSelectedSubjects: array3
        })

        let onloadClasses = data?.class_ids?.split(",")
        let totalClasses = this.props.getExamClasses || []

        let classArray = [];
        let classIdsArray = [];

        if (onloadClasses != undefined) {
            totalClasses.map((item) => {
                onloadClasses.map((item2) => {
                    if (item.id == item2) {
                        classArray.push({ value: item.id, label: item.class })
                        classIdsArray.push(item.id)
                    }
                })
            })
        }

        this.setState({
            preSelectedClasses: classArray,
            qbsearchClasses: classIdsArray,
        })

        // branch_id is a comma-separated list of branch ids (multi-branch access)
        let onloadBranches = data?.branch_id ? String(data.branch_id).split(",") : []
        let totalBranches = this.props.getBranches || []

        let branchArray = [];
        let branchIdsArray = [];

        onloadBranches.forEach((bid) => {
            const match = totalBranches.find((b) => String(b.id) === String(bid).trim())
            if (match) {
                branchArray.push({ value: match.id, label: match.branch_name })
                branchIdsArray.push(match.id)
            }
        })

        // Section options follow the employee's branches AND classes; pre-select the
        // sections saved against this employee. getEmployeeDetails returns section_ids
        // and section_names as parallel comma-separated lists.
        const sectionsOptions = getSectionsForSelection(branchIdsArray, classIdsArray, this.props.getBranches);
        const onloadSectionIds = data?.section_ids ? String(data.section_ids).split(",").map((s) => s.trim()).filter(Boolean) : []
        const onloadSectionNames = data?.section_names ? String(data.section_names).split(",").map((s) => s.trim()) : []

        let sectionArray = [];
        let sectionIdsArray = [];
        onloadSectionIds.forEach((sid, i) => {
            // Prefer the label from the derived options; fall back to section_names
            // (and finally the id) so a saved section still shows even if the
            // branch/class filter didn't surface it.
            const match = sectionsOptions.find((s) => String(s.value) === String(sid))
            const label = match ? match.label : (onloadSectionNames[i] || sid)
            const value = match ? match.value : sid
            sectionArray.push({ value, label })
            sectionIdsArray.push(value)
        })

        // Ensure every pre-selected section exists in the options list, otherwise
        // the multi-select can't render the selected chip.
        const sectionOptionValues = new Set(sectionsOptions.map((s) => String(s.value)))
        sectionArray.forEach((s) => {
            if (!sectionOptionValues.has(String(s.value))) {
                sectionOptionValues.add(String(s.value))
                sectionsOptions.push({ value: s.value, label: s.label })
            }
        })

        // Class options follow the employee's branches: only classes wired to those
        // branches' sections are selectable.
        this.setState({
            preSelectedBranches: branchArray,
            qbsearchBranches: branchIdsArray,
            classesOptions: getClassesForBranches(branchIdsArray, this.props.getBranches, this.props.getExamClasses),
            sectionsOptions,
            preSelectedSections: sectionArray,
            qbsearchSections: sectionIdsArray,
            sectionError: "",
        })
    }

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            this.setState({ submitError: "Invalid format. Only JPEG and PNG files are allowed." });
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            this.setState({
                selectedImageFile: file,
                selectedImageBase64: reader.result,
                selectedImageName: file.name,
                submitError: "",
            });
        };
        reader.readAsDataURL(file);
    }

    handleImageRemove = (e) => {
        if (e) e.preventDefault();
        this.setState({ selectedImageBase64: "", selectedImageName: "", selectedImageFile: null, profileImage: "" });
    }

    deleteEmployee = async (employee_id) => {
        // is_delete gate — checked BEFORE the confirm prompt, so a role without delete is
        // told they lack access rather than asked to confirm a delete that can't happen.
        if (!this.guard.requireDelete()) return;
        if (!window.confirm("Are you sure you want to delete this employee?")) {
            return;
        }
        await this.props.deleteEmployee({
            variables: {
                employee_id
            },
            update: (store, { data }) => {
                if (data.deleteEmployee) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        })
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        if (this.state.submitError) {
            this.setState({ submitError: "" });
        }

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (name == "branch") {
            this.setState({ branch: value, branchError: "" })
        }
        if (name == "user_name") {
            this.setState({ Username: value, usernameError: "" })
        }
        if (name == "login_user_name") {
            this.setState({ loginUsername: value, loginUsernameError: "" })
        }
        if (name == "password") {
            this.setState({ password: value, passwordError: "" })
        }
        if (name == "email") {
            this.setState({ email: value })
            if (value != "" && !pattern.test(value)) {
                this.setState({ emailError: "Please enter valid Email" })
            } else {
                this.setState({ emailError: "" })
            }
        }
        if (name == "contact_no") {
            const digits = value.replace(/\D/g, "").slice(0, 10)
            this.setState({ contact_no: digits, contact_noError: "" })
            if (digits.length > 0 && digits.length < 10) {
                this.setState({ contact_noError: "Mobile number must be 10 digits" })
            } else {
                this.setState({ contact_noError: "" })
            }
        }
        if (name == "employeetype") {
            this.setState({ employeeType: value, employeeTypeError: "" })
        }
        if (name == "role") {
            this.setState({ selectedRole: value, roleError: "" })
        }
    };

    handleMultipleSelectInputChange = (e, name) => {

        if (this.state.submitError) {
            this.setState({ submitError: "" });
        }
        if (name == "modules") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let modulesArray = Array();
            let finalModulesArray = Array()

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                        enabled: false,
                    }

                    const newObj1 = {
                        label: qbtopicval.label,
                        enabled: false,
                        value: qbtopicval.value
                    }

                    const newObj2 = {
                        module_name: qbtopicval.label,
                        enabled: false,
                    }

                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                    modulesArray.push(newObj1)
                    finalModulesArray.push(newObj2)
                }
                this.setState({
                    modulesValue: qbsearchtopicvalue,
                    qbsearchModules: qbsearchtopic,
                    prefilledModules: modulesArray,
                    selectedModulesArrayError: "",
                    finalModulesArrayPass: finalModulesArray

                });
            }
        }

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    preSelectedSubjects: qbsearchtopicvalue,
                    preSelectedsubjectValues: qbsearchtopic,
                });
            }
        }

        if (name == "classes") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                // Sections depend on the picked classes — re-derive their options for
                // the new class selection and drop any now-invalid section picks.
                const sectionsOptions = getSectionsForSelection(this.state.qbsearchBranches, qbsearchtopic, this.props.getBranches);
                const validSectionIds = new Set(sectionsOptions.map((s) => String(s.value)));
                const preSelectedSections = (this.state.preSelectedSections || []).filter((s) => validSectionIds.has(String(s.value)));
                const qbsearchSections = (this.state.qbsearchSections || []).filter((id) => validSectionIds.has(String(id)));

                this.setState({
                    preSelectedClasses: qbsearchtopicvalue,
                    qbsearchClasses: qbsearchtopic,
                    classError: "",
                    sectionsOptions,
                    preSelectedSections,
                    qbsearchSections,
                });
            }
        }

        if (name == "sections") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    qbsearchtopicvalue.push({ label: qbtopicval.label, value: qbtopicval.value });
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    preSelectedSections: qbsearchtopicvalue,
                    qbsearchSections: qbsearchtopic,
                    sectionError: "",
                });
            }
        }

        if (name == "branches") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    qbsearchtopicvalue.push({ label: qbtopicval.label, value: qbtopicval.value });
                    qbsearchtopic.push(qbtopicval.value);
                }
            }

            // Re-derive the class options for the new branch selection, then drop any
            // previously-picked classes that no longer belong to the chosen branches.
            const classesOptions = getClassesForBranches(qbsearchtopic, this.props.getBranches, this.props.getExamClasses);
            const validClassIds = new Set(classesOptions.map((c) => String(c.value)));
            const preSelectedClasses = (this.state.preSelectedClasses || []).filter((c) => validClassIds.has(String(c.value)));
            const qbsearchClasses = (this.state.qbsearchClasses || []).filter((id) => validClassIds.has(String(id)));

            // Sections depend on branch AND class: re-derive from the new branches and
            // the still-valid classes, then drop any picked sections now out of range.
            const sectionsOptions = getSectionsForSelection(qbsearchtopic, qbsearchClasses, this.props.getBranches);
            const validSectionIds = new Set(sectionsOptions.map((s) => String(s.value)));
            const preSelectedSections = (this.state.preSelectedSections || []).filter((s) => validSectionIds.has(String(s.value)));
            const qbsearchSections = (this.state.qbsearchSections || []).filter((id) => validSectionIds.has(String(id)));

            this.setState({
                preSelectedBranches: qbsearchtopicvalue,
                qbsearchBranches: qbsearchtopic,
                branchError: "",
                classesOptions,
                preSelectedClasses,
                qbsearchClasses,
                sectionsOptions,
                preSelectedSections,
                qbsearchSections,
            });
        }
    }

    handleFormSubmit = async () => {

        if (this.state.Username == "") {
            this.setState({ usernameError: "Please Enter Username", })
            return ""
        }

        if (this.state.loginUsername == "") {
            this.setState({ loginUsernameError: "Please enter user name" })
            return ""
        }

        if (this.state.password == "") {
            this.setState({ passwordError: "Please Enter Password", })
            return ""
        }
        if (this.state.contact_no == "" || this.state.contact_no.length > 10 || this.state.contact_no.length < 10) {
            this.setState({ contact_noError: "Please Enter valid Contact number", })
            return ""
        }

        if (this.state.selectedRole == "" || this.state.selectedRole == 0) {
            this.setState({ roleError: "Please Select Role" })
            return ""
        }

        // Branch is optional — no required validation here.

        if (this.isTeacherRole() && this.state.qbsearchClasses.length == 0) {
            this.setState({ classError: "Please select Class" })
            return ""
        }

        if (this.isTeacherRole() && this.state.preSelectedsubjectValues.length == 0) {
            this.setState({ selectedsubjectsError: "Please select Subjects" })
            return ""
        }

        this.setState({ loadingSpinner: 1, submitError: "" });

        let profileImageUrl = this.state.profileImage;

        if (this.state.selectedImageBase64) {
            try {
                const response = await this.props.client.mutate({
                    mutation: gql`
                        mutation FileUpload($params: FileUploadInput!) {
                            fileUpload(params: $params) {
                                uuid
                                file_url
                                file_extension_type
                                file_name
                            }
                        }
                    `,
                    variables: {
                        params: {
                            category: "userImages",
                            client_id: parseInt(Cookies.get("institutionid")),
                            file: [
                                {
                                    img: this.state.selectedImageBase64,
                                    filename: this.state.selectedImageName
                                }
                            ]
                        }
                    }
                });

                const fileUploadResult = response?.data?.fileUpload;
                const result = Array.isArray(fileUploadResult) ? fileUploadResult[0] : fileUploadResult;
                if (result && result.file_url) {
                    profileImageUrl = result.file_url;
                } else {
                    this.setState({ loadingSpinner: 0, submitError: "Upload failed." });
                    return;
                }
            } catch (err) {
                console.error("Upload error:", err);
                this.setState({ loadingSpinner: 0, submitError: "Error uploading profile image." });
                return;
            }
        }

        let params = {
            id: parseInt(this.state.employeeId),
            employee_name: this.state.Username,
            username: this.state.loginUsername,
            emp_mobile: this.state.contact_no,
            emp_email: this.state.email,
            password: this.state.password,
            employee_role_id: this.state.selectedRole,
            subject_ids: (this.state.preSelectedsubjectValues || []).toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            class_ids: (this.state.qbsearchClasses || []).toString(),
            section_ids: (this.state.qbsearchSections || []).toString(),
            branch_id: (this.state.qbsearchBranches || []).join(","),
            module_access: this.state.finalModulesArrayPass || [],
            profile_image: profileImageUrl,
        }

        this.updateEmployeeRestrictions(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpinner: 0,
            });
        });
    }

    updateEmployeeRestrictions = async params => {
        await this.props.updateEmployeeRestrictions({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.updateEmployeeRestrictions) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0, editModal: false });
        // refresh the employee list in-place instead of reloading the whole page
        if (this.props.refetchEmployees) {
            this.props.refetchEmployees();
        }
    };

    handleRoleFilterChange = (e) => {
        this.setState({ roleFilter: e.target.value });
    };

    // Employee rows for the table, narrowed to the selected role.
    getFilteredEmployees = () => {
        // The shared table keys rows by `id`, but getEmployeeDetails returns
        // `employeeId` (no `id`). Without a key the table renders no rows.
        const rows = (this.props.getEmployeeDetails || []).map((r) => ({ ...r, id: r.employeeId }));
        return filterEmployeesByRole(rows, this.state.roleFilter, this.state.roles);
    };

    render() {
        const FIN = {
            wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            headerActions: { display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            content: { padding: "20px 24px" },
            shell: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" },
            filterSelect: { height: 42, borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#1f2937", fontSize: 13, fontWeight: 600, padding: "0 34px 0 12px", cursor: "pointer", appearance: "none", backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%2364748b'%3E%3Cpath d='M4.5 6l3.5 3.5L11.5 6'/%3E%3C/svg%3E\")", backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center", backgroundSize: 14, minWidth: 170 },
        };

        // is_view === 0 → the role can't open this module; show Access Denied instead of the page.
        if (!canView(EMPLOYEE_RESTRICTIONS_MODULE, EMPLOYEE_RESTRICTIONS_SUB)) {
            return (
                <div style={FIN.wrapper}>
                    <AccessDeniedCard />
                </div>
            );
        }

        const tabs = [
            { key: "employees", label: "Employees", icon: "fal fa-users", path: "/settings/staff" },
            { key: "roles", label: "Roles", icon: "fal fa-user-tag", path: "/settings/roles" },
            { key: "moduleAccess", label: "Module Access", icon: "fal fa-sliders-h", path: "/settings/module-access" },
        ];
        // drive the active tab from the route so the sidebar links open the right tab
        const PATH_TO_KEY = {
            "/settings/staff": "employees",
            "/settings/employee-restrictions": "employees",
            "/settings/roles": "roles",
            "/settings/module-access": "moduleAccess",
        };
        const pathname = this.props.location && this.props.location.pathname;
        const activeTab = PATH_TO_KEY[pathname] || "employees";

        const filteredEmployees = this.getFilteredEmployees();
        const totalEmployees = (this.props.getEmployeeDetails || []).length;

        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.shell}>

                        {/* Finance-style tab header */}
                        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
                            <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                                {tabs.map((tab) => {
                                    const isActive = activeTab === tab.key;
                                    return (
                                        <li className="nav-item" key={tab.key}>
                                            <a
                                                className={`nav-link ${isActive ? "active" : ""}`}
                                                href={tab.path}
                                                onClick={(e) => { e.preventDefault(); this.props.history.push(tab.path); }}
                                                style={{
                                                    cursor: "pointer",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    padding: "12px 20px",
                                                    color: isActive ? "#6366f1" : "#4b5563",
                                                    background: isActive ? "#fff" : "transparent",
                                                    borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                                    borderWidth: "1.5px",
                                                    borderBottomWidth: isActive ? "2px" : "1.5px",
                                                    borderRadius: "10px 10px 0 0",
                                                    transition: "all 0.15s ease",
                                                    marginBottom: "-1.5px",
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <i className={tab.icon} />
                                                {tab.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {/* Content panel */}
                        <div style={{ padding: 28 }}>
                            {activeTab === "employees" && (
                                <div style={FIN.card}>
                                    {/* Header */}
                                    <div style={FIN.cardHeader}>
                                        <div style={FIN.iconWrapper}><i className="fal fa-user-shield" /></div>
                                        <div style={FIN.cardTitleText}>
                                            <h5 style={FIN.cardTitle}>Employee</h5>
                                            <span style={FIN.cardSubtitle}>
                                                {/* Make it obvious the list is narrowed, so a filtered-to-zero
                                                    result doesn't read as "no employees exist". */}
                                                {this.state.roleFilter
                                                    ? `Showing ${filteredEmployees.length} of ${totalEmployees} employees`
                                                    : "Manage employees, module access & permissions"}
                                            </span>
                                        </div>
                                        <div style={FIN.headerActions}>
                                            {/* Role filter. Options come from getEmployeeRoles (already
                                                fetched in componentDidMount), so new roles show up here
                                                automatically — nothing is hardcoded. */}
                                            <select
                                                name="roleFilter"
                                                value={this.state.roleFilter}
                                                onChange={this.handleRoleFilterChange}
                                                style={FIN.filterSelect}
                                                aria-label="Filter employees by role"
                                            >
                                                <option value="">All Roles</option>
                                                {this.state.roles.map((role) => (
                                                    <option key={role.id} value={role.id}>
                                                        {role.role_name}
                                                    </option>
                                                ))}
                                            </select>

                                            <button
                                                style={FIN.btnPrimary}
                                                onClick={() => { if (this.guard.requireEdit()) this.setState({ modalShow: true }); }}
                                            >
                                                <i className="fas fa-user-plus" /> Add Employee
                                            </button>
                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div style={FIN.content}>
                                        <CardLessDataTableWithSearch
                                            parentData={filteredEmployees}
                                            particlecolumns={this.articlecolumns}
                                            placeholder="Search employees"
                                        />
                                    </div>
                                </div>
                            )}

                            {activeTab === "roles" && <RolesTab />}

                            {activeTab === "moduleAccess" && (
                                <ModuleAccessTab
                                    getCollegeModules={this.props.getCollegeModules}
                                    globals={this.props.globals}
                                    getBranches={this.props.getBranches}
                                />
                            )}
                        </div>
                    </div>
                </Container>

                <EmployeeModal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    refetchEmployees={this.props.refetchEmployees}
                    getEmployeeTypes={this.props.getEmployeeTypes}
                    getCollegeModules={this.props.getCollegeModules}
                    getExamClasses={this.props.getExamClasses}
                    getBranches={this.props.getBranches}
                    globals={this.props.globals}
                />
                <EditEmployeeModal
                    show={this.state.editModal}
                    onHide={() => this.setState({ editModal: false })}
                    getEmployeeTypes={this.props.getEmployeeTypes}
                    getCollegeModules={this.props.getCollegeModules}
                    getExamClasses={this.props.getExamClasses}
                    getBranches={this.props.getBranches}
                    globals={this.props.globals}
                    stateData={this.state}
                    handleInputChange={this.handleInputChange}
                    handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                    handleFormSubmit={this.handleFormSubmit}
                    handleImageChange={this.handleImageChange}
                    handleImageRemove={this.handleImageRemove}
                />

                {/* Shown when a role without is_edit / is_delete clicks Add / Edit / Delete. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </div>
        )
    }

}


export default withRouter(
    compose(
        withApollo,
        graphql(EDIT_RESTRICTIONS, {
            name: "updateEmployeeRestrictions"
        }),
        graphql(DELETE_EMPLOYEE, {
            name: "deleteEmployee"
        })
    )(EmployeeRestrictionsSection)
);